import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  public videoUrl: string | SafeResourceUrl;
  public isYouTubeEmbed = false;

  constructor(
    private router: Router,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    if (window.location.href.indexOf("/fr/") > -1) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/9SHx3abT8ro");
      this.isYouTubeEmbed = true;
    } else if (window.location.href.indexOf("/es/") > -1) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/tm-RmTs_yiA");
      this.isYouTubeEmbed = true;
    } else if (window.location.href.indexOf("/ko/") > -1) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/zoHYo4QBztg");
      this.isYouTubeEmbed = true;
    } else if (window.location.href.indexOf("/pt/") > -1) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/zoHYo4QBztg");
      this.isYouTubeEmbed = true;
    } else if (window.location.href.indexOf("/ar/") > -1) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/zoHYo4QBztg");
      this.isYouTubeEmbed = true;
    } else {
      // Default to local video for English
      this.videoUrl = "/assets/landing_video/landing_latest.mp4";
      this.isYouTubeEmbed = false;
    }
  }

  registerClick() {
    this.router.navigateByUrl('/register');
  }

  loginClick() {
    this.router.navigateByUrl('/login');
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/landing.component.ts